import React from 'react';
import P from '@leverege/promise';
import I18N from '@leverege/i18n';
import { Dialog, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { LoadingView } from '@leverege/molten/views';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.lost.markAsFound.MarkAsFoundDialog');
const {
  tIcon
} = I18N.ns('recovr.icons');
async function markDevicesAsFound(targets) {
  const successes = [];
  await P.mapLimit(targets, async target => {
    const locationId = target?.data?.data?.location?.id;
    const deviceId = target?.id;
    const res = await GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      const nApi = api.interface(process.env.SYSTEM_ID, 'location').obj(locationId);
      let res;
      try {
        res = await nApi.srv('recovr').post('lost/markAsFound', {
          deviceId
        });
      } catch (err) {
        Toast.error([t('error'), err?.message]);
      }
      return res;
    });
    if (res && !res?.error && (!res.status || res.status === 200 || res.status === 201)) {
      successes.push(res);
    }
  });
  if (successes.length > 0) Toast.success(t('success', {
    count: successes.length
  }));
}
export default function MarkAsFoundDialog(props) {
  const {
    show,
    onClose,
    targets
  } = props;
  const onOkay = async () => {
    const closeLoading = LoadingView.showDialog(t('loadingTitle'));
    await markDevicesAsFound(targets);
    closeLoading();
    onClose();
  };
  return /*#__PURE__*/_jsx(Dialog.Question, {
    show: show,
    eventData: props,
    title: t('title'),
    icon: tIcon('markAsFound'),
    message: t('enabledMessage', {
      count: targets.length
    }),
    okay: t('confirm'),
    okayVariant: "primary",
    onCancel: onClose,
    onOkay: onOkay
  });
}